
<div class="cdk-overlay-container">
    <div class="cdk-overlay-backdrop cdk-overlay-dark-backdrop cdk-overlay-backdrop-showing"></div>
    <div class="cdk-global-overlay-wrapper" dir="ltr" style="justify-content: center; align-items: center;">
        
    <div id="cdk-overlay-0" class="cdk-overlay-pane" style="max-width: 80vw; position: static;">

        <!-- <mat-dialog-container tabindex="-1" aria-modal="true" class="mat-dialog-container ng-tns-c85-74 ng-trigger ng-trigger-dialogContainer ng-star-inserted" id="mat-dialog-0" role="dialog" style="transform: none;"> -->
            


<div class="ttmodal" [style]="setWindowPosition(positionX, positionY)" id="schematicmasterWindow">

<!-- <div class="ttmodal cdk-overlay-pane" id="schematicmasterWindow" appMovable click="matSelectCompType.close()"> -->
    <div id="schematicWindowHeader_" class="ttmodal__header" style="margin-bottom: 10px;">
        <span class="ttmodal__title" style="margin-top: 18px;margin-left: 25px;">Schematic and Observation Point</span>
        <div class="panel__header__button-container">

            <a class="button waves-effect" style="margin-top: 10px;" (click)="onCloseClick()">
                <i class="material-icons button__icon">cancel</i>
                <span class="button__text">Close</span>
            </a>
        </div>
    </div>

    <div class="ttmodal__body" style="height: 600px;">
        <div style="display: flex;flex-direction: row;justify-content: flex-start">


            <add-observation-point *ngIf="showAddObservation" [(cusID)]="CustomerId" [(implementID)]="ImplementId"
                [(showOPWindow)]="showAddObservation" (closeObservationWindow)="onCloseObservationWindow($event)"
                [(positionX)]="eventX" [(positionY)]="eventY" [(schematicID)]="schematic" style="width: 620px;margin-top: -8px;border-radius: -9px; width:620px;"
                [class.nodisplay]="!showAddObservation"> </add-observation-point>

            <div class="ttmodal" id="schematicWindow">
                <div id="schematicWindowHeader" class="ttmodal__header">
                    <span class="ttmodal__title"></span>
                    <div class="panel__header__button-container" id="closeButton">

                        <a *ngIf="isTemplate" class="button waves-effect" (click)="fileInput.click()">
                            <i class="material-icons button__icon">edit</i>
                            <span class="button__text">Edit Image</span>
                        </a>

                        <!-- <a class="button waves-effect" (click)="onCloseClick()">
                                <i class="material-icons button__icon">cancel</i>
                                <span class="button__text">Close</span> 
                            </a> -->
                    </div>

                </div>

               
                <div id="schematicWindowHeader" >
                    <div style="display: flex; flex-direction: row;">
                        <input style="font-size: 20px;display: flex; justify-content: space-around;" [(ngModel)]="title"
                            (focusout)="UpdateSchmaticImageName()">
                    </div>
                    <!-- <div style="display: flex; flex-direction: row; " *ngIf="ImplementId>0">
                            <span style="align-self: center;min-width: 102px; margin-right: 20px;">Component Type</span>
                          <mat-form-field style="width: 56%;">
                                <mat-select style="width: 345px" [(ngModel)]="componentType" ngDefaultControl
                                    (change)="UpdateComponentType()">
                                    <mat-option value="" disabled selected>Select Component Type</mat-option>
                                    <mat-option *ngFor="let component of componentTypeList"
                                        [value]="component.Id">{{component.Name}}</mat-option>
                                </mat-select>
                            </mat-form-field>
    
                        </div> -->


                </div>

                <div style="display: flex; flex-direction: row wrap;justify-content: space-around; " *ngIf="ImplementId>0">
                    <mat-form-field class="header-form-full-width" hasBackdrop="false">
                        <span style="align-self: center; min-width: 102px;">Component Type</span>
                        <mat-select [formControl]="ComponentTypeVMForm" (selectionChange)="LoadForms()" #matSelectCompType
                            multiple>
                            <mat-option *ngFor="let component of componentTypeList" 
                                [value]="component.Id">{{component.Name}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <div *ngIf="ImplementId>0"  (click)="saveUpdateComponentType(ComponentTypeVM)">

                        <a class="button button--primary">
                            <span class="button__text">Save</span>
                        </a>

                    </div>

                </div>


                <div class="ttmodal__body" style="height: 600px;">
                    <div *ngIf="schematic != null"
                        style="width: auto; height: auto; position: relative; margin-left: 2px;">
                        <img [src]="getImage(schematic.Data)" style="width: 100%;height: 100%;"
                            (click)="openObservationPointModal($event)">
                        <ng-container *ngIf="schematic.ObservationPoints != null">
                            <ng-container *ngFor="let cp of schematic.ObservationPoints">

                                <i class="material-icons button__icon component-dot" *ngIf="cp.ObPointTypeId != 2 && cp.ObservationType != 'Crack'"
                                    [class.green-eval]="getEval(cp.WornPct, cp.InspectionDate) == 'green'"
                                    [class.yellow-eval]="getEval(cp.WornPct, cp.InspectionDate) == 'yellow'"
                                    [class.orange-eval]="getEval(cp.WornPct, cp.InspectionDate) == 'orange'"
                                    [class.red-eval]="getEval(cp.WornPct, cp.InspectionDate) == 'red'"
                                    [class.no-eval]="getEval(cp.WornPct, cp.InspectionDate) == 'gray'"
                                    [class.default]="getEval(cp.WornPct, cp.InspectionDate) == 'magenta'"
                                    [class.component-dot2]="mouseoverOPId == cp.Id" 
                                    (mouseover)="onMouseOverOP(cp.Id)"
                                    (mouseout)="onMouseOutOP(cp.Id)" 
                                    matTooltip="{{cp.Name}} ({{cp.WornPct}}% Worn) Last Inspection - {{cp.InspectionDate}} X,Y coord: {{cp.PositionX}},{{cp.PositionY}}"
                                    [style]="getPosition(cp.PositionX, cp.PositionY)">lens</i>

                                    <div *ngIf="cp.EndPositionX!=null && cp.EndPositionX !=0 " 
                                    [class.component-dot2]="mouseoverOPId == cp.Id" 
                                    [class.yellow-eval]="getEval(cp.WornPct, cp.InspectionDate) == 'yellow'"
                                    (mouseenter)="onMouseOverOP(cp.Id)" 
                                    (mouseleave)="onMouseOutOP(0)"
                                    matTooltip="{{cp.Name}} Crack Date - {{cp.InstallDate}} - Current Length {{cp.CurrentLength}} {{userUOM}} - Crack Status {{cp.CrackStatus}}
                                    {{cp.CrackSeverity != null ? ' - Severity ' + cp.CrackSeverity : ''}} - {{ cp.CrackStatusId === 1 ? '' : ' - (' + cp.WornPct + '% Worn)' }}"
                                    [style]="getLine(cp.PositionX, cp.PositionY,cp.EndPositionX, cp.EndPositionY,cp.IsCrackFixed)"></div>
                            </ng-container>
                            <!-- <ng-container *ngIf="TempObservationPoints.Id ==-1">
                                        <i class="material-icons button__icon  " [class.default]="getEval(cp.WornPct, cp.InspectionDate) == 'magenta'"></i>
                                    </ng-container> -->
                        </ng-container>
                    </div>
                </div>
            </div>


            <input style="display: none;" type="file" #fileInput (change)="ReplaceImage($event)">
        </div>




    </div>
</div>

<!-- </mat-dialog-container> -->
</div>
</div>
</div>